import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    threads: null,
    activeChat: null,
    activeChatId: null,
}

const chatslice = createSlice({
    name: "chat",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            localStorage.setItem('user', null);
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeThreads: (state, action) => {
            state.threads= action.payload;
        },
        clearThreads: (state, action) => {
            state.threads= null;
        },
        addToThreadsInStore: (state, action) => {
            state.threads= [...state.threads, action.payload];
        },
        editThreadInStore: (state, action) => {
            state.threads= state.threads.map((item)=>{
                if( action.payload && item.id === action.payload.id){
                    return action.payload;
                }else{
                    return item;
                }
            });
        },
        deleteThreadInStore: (state, action) => {
            state.threads= state.threads.filter(item => item.id!==action.payload);
        },
        storeActiveChatId: (state, action) => {
            state.activeChatId = action.payload;
        },
        clearActiveChatId: (state) => {
            state.activeChatId= null;
        },
        storeActiveChat: (state, action) => {
            state.activeChat = action.payload;
        },
        clearActiveChat: (state,action) => {
            state.activeChat= null;
        },
        addToActiveChat: (state,action)=> {
            state.activeChat= state.activeChat?[...state.activeChat, action.payload]:[action.payload]
        },
        updateConversationFeedback: (state, action) => {
            state.activeChat= state.activeChat.map((item)=>{
                if(action.payload && item.questionId === action.payload.questionId){
                    return {...item, ...action.payload};
                }else{
                    return item;
                }
            });
        },
    }
})

export const { storeThreads, clearThreads, addToThreadsInStore, editThreadInStore, deleteThreadInStore, storeActiveChat, clearActiveChat, updateConversationFeedback, storeActiveChatId, clearActiveChatId, addToActiveChat } = chatslice.actions
export default chatslice.reducer